
import { defineComponent } from 'vue'
import { formatRepoName } from '~/utils/string'

export default defineComponent({
  name: 'ToggleMonorepoConfirm',

  props: {
    isMonorepo: {
      type: Boolean,
      required: true
    },
    teamName: {
      type: String,
      required: true
    },
    repoName: {
      type: String,
      required: true
    },
    togglingMonorepoMode: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      enteredName: ''
    }
  },

  computed: {
    formattedRepoName(): string {
      return formatRepoName(this.repoName)
    },

    computedBindings() {
      if (this.isMonorepo) {
        return {
          title: 'Disable monorepo mode',
          iconColor: 'cherry-500',
          confirmButtonBindings: {
            'button-type': 'danger',
            label: 'Disable monorepo mode',
            'loading-label': 'Disabling monorepo mode'
          }
        }
      }

      return {
        title: 'Enable monorepo mode',
        iconColor: 'juniper-500',
        confirmButtonBindings: {
          'button-type': 'primary',
          label: 'Enable monorepo mode',
          'loading-label': 'Enabling monorepo mode'
        }
      }
    },

    validationText(): string {
      return `${this.teamName}/${this.formattedRepoName}`
    }
  }
})
